module.exports = "https://cdn.littlereply.com/tt/resource/feed_empty.0a50900a8bbccde975e02783a712c9d8.png";